import { PreAuthorizedBaseData } from './pre-authorized-base-data';

export class PreAuthorizationSessionVerifyData extends PreAuthorizedBaseData {
  public authorizationId: string;

  constructor(type: string, hash: string, customerId: string, username: string, authorizationId: string) {
    super(type, hash, customerId, username);
    this.authorizationId = authorizationId;
  }
}
